import { render } from "./productMenu.vue?vue&type=template&id=49c5fdb1&scoped=true"
import script from "./productMenu.vue?vue&type=script&lang=js"
export * from "./productMenu.vue?vue&type=script&lang=js"

import "./productMenu.vue?vue&type=style&index=0&id=49c5fdb1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c5fdb1"]])

export default __exports__